import { LoadingButton } from "@mui/lab";
import {  useState } from "react";
import {  useSelector } from "react-redux";
import NoDataCard from '../../../../../../components/no-data-card';
import { Box } from '@mui/material';
import { selectFollowCycle,selectCoaInfo } from '../../../../../slices/common';

import COAPrint from '../../../../Manufacturer/COAPrint';

const DownloadCOAForm = ({patientData}) => {
 const currentCycle = useSelector(selectFollowCycle);
    const [coaPrintModal, setCoaPrintModal] = useState(false)
     const checkCOAForm =  useSelector(selectCoaInfo)  

    const handleCoaPrint = () => {
        setCoaPrintModal(true)
    }

    return (
        <>

            {currentCycle?.coa_forms_id
                ?
                (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <LoadingButton
                                type="button"
                                size="small"
                                onClick={handleCoaPrint}
                                className="!w-[100px] "
                            >
                                Print
                            </LoadingButton>
                        </Box>
                        {(checkCOAForm && currentCycle?.coa_forms_id) && (
                             <COAPrint
                                    open={coaPrintModal}
                                    onClose={() => {
                                        setCoaPrintModal(false);
                                    }}
                                    printData={checkCOAForm}
                                    patientInfo={{...patientData,batch_no:currentCycle?.batch_no}}
                                    isVisible={true}
                                />
                        )}
                    </>
                ) : (
                    <div >
                        <NoDataCard heading="No Data to Display" />
                    </div>
                )
            }
        </>
    );

}

export default DownloadCOAForm